import MVdxbProgress from './index.vue';

MVdxbProgress.install = app => {
  app.component(MVdxbProgress.name, MVdxbProgress);
};

export default MVdxbProgress;
